<template>
  <lsSearchForm
    ref="lsSearchForm"
    @search="handleSearch"
    :initExpand="false"
    :formList="formList"
    :searchContentFold="false"
  >
    <!--加工组织-->
    <global-select
      slot="organizationCode"
      requestApi="/system/user/inventOrgAll"
      :selectItem="{ value: 'realValue', label: 'label' }"
      :dropdown-match-select-width="false"
      v-decorator="['organizationCode', { initialValue: this.organizationCodeOrigin || '' }]"
      :assembleLabel="true"
      :allowClear="false"
      :disabled="isDisableOrganization"
      @change="onChangeOrg"
    />
    <global-select
      slot="centerCode"
      v-decorator="['centerCode']"
      selectType="selectAssembleSearch"
      assembleLabel
      searchParam="centerName"
      focusGet
      requestApi="/bom/workCenter/list"
      :selectItem="{ value: 'centerCode', label: 'centerName' }"
      :setParams="{ organizationCode: formData.organizationCode }"
      @change="onChangeCenter"
    />
    <global-select
      slot="teamGroupCode"
      v-decorator="['teamGroupCode']"
      selectType="selectSearch"
      searchParam="teamName"
      focusGet
      requestApi="/bom/team/list"
      :selectItem="{ value: 'teamCode', label: 'teamName' }"
      :setParams="{ organizationCode: formData.organizationCode }"
    />
    <a-month-picker
      slot="produceTimeMonth"
      valueFormat="YYYY-MM"
      :allowClear="false"
      v-decorator="['produceTimeMonth', { initialValue: $moment() }]"
    />
    <a-range-picker
      slot="produceTimeDay"
      :allowClear="false"
      v-decorator="['produceTimeDay', { initialValue: [$moment().subtract(1, 'days'), $moment().subtract(1, 'days')] }]"
    />
    <global-select
      slot="employeeCode"
      v-decorator="['employeeCode']"
      selectType="select"
      focusGet
      requestApi="/bom/team/employee/list"
      :selectItem="{ value: 'employeeCode', label: 'employeeName' }"
      :setParams="{ organizationCode: formData.organizationCode }"
    />
  </lsSearchForm>
</template>

<script>
import isNil from 'lodash/isNil';
import { mapState } from 'vuex';
import { DAY_SEARCH_LIST, MONTH_SEARCH_LIST, PIECEWORK_WAGE_TABLE } from '../common.js'

export default {
  name: 'SearchForm',
  components: {},
  props: {
    tableKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {}
    }
  },
  created() {
    this.formData = {
      organizationCode: this.organizationCodeOrigin
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'; // 林氏产业园库存组织可
    },
    formList() {
      return {
        [PIECEWORK_WAGE_TABLE.day.id]: DAY_SEARCH_LIST,
        [PIECEWORK_WAGE_TABLE.month.id]: MONTH_SEARCH_LIST
      }[this.tableKey]
    }
  },
  methods: {
    onChangeCenter() {
      this.$refs.lsSearchForm.form.setFieldsValue({
        teamGroupCode: undefined
      })
      setTimeout(() => {
        this.formData = this.$refs.lsSearchForm.form.getFieldsValue()
      }, 100)
    },
    onChangeOrg() {
      this.$refs.lsSearchForm.form.setFieldsValue({
        workCenterCode: undefined,
        teamGroupCode: undefined
      })
      setTimeout(() => {
        this.formData = this.$refs.lsSearchForm.form.getFieldsValue()
      }, 100)
    },
    handleSearch(values) {
      this.$nextTick(() => {
        for(const filed in values) {
          if(isNil(values[filed]) || values[filed] === '') {
            delete values[filed]
          }
        }
        if(values.produceTimeMonth) {
          values.produceTime = this.$moment(values.produceTimeMonth).format('YYYY-MM-01 00:00:00');
        }
        if(values.produceTimeDay?.length) {
          values.produceTimeStart = values.produceTimeDay[0].format("YYYY-MM-DD 00:00:00");
          values.produceTimeEnd = values.produceTimeDay[1].format("YYYY-MM-DD 23:59:59");
        }
        delete values.produceTimeDay;
        delete values.produceTimeMonth;
        delete values.searchFormLabel
        this.$emit("search", values);
      })
    },
    handleFormSearch() {
      this.$refs.lsSearchForm.handleSearch();
    }
  }
}
</script>

<style lang="less" scoped></style>
